module.exports = __webpack_public_path__ + "static/media/eating__mobile.38aee4a8.gif";